import { Modal } from 'react-bootstrap'
import Addmeeting from './Addmeeting'

const Editmeeting = ({meetingInfo, meetingid, hide, show,getMeetingListData,GetMeetingDetails ,iscategory}) => {
  return (
    <Modal
      show={show}
      onHide={hide}
      size='xl'
      centered
      style={{backdropFilter:"blur(6px)"}}
    >
      <Modal.Body className="p-0">
        <Addmeeting iscategory={iscategory} meetingInfo={meetingInfo} meetingid={meetingid} hide={hide} getMeetingListData={getMeetingListData} GetMeetingDetails={GetMeetingDetails}/>
      </Modal.Body>
    </Modal>
  )
}

export default Editmeeting